import { getApi, postApi, putApi } from "./apiService";

export const addMerchantDetails = async (merchantDetails) => {
    return await postApi("/mp/merchant/register", merchantDetails);
}

export const getMerchantDetails = async () => {
    return await getApi("/mp/merchant/getMerchant")
}

export const updateMerchantDetails = async (updatedData) => {
    return await putApi("/mp/merchant/update-merchant", updatedData)
}

export const updateMerchantPassword = async (updatedData) => {
    return await putApi("/mp/merchant/update-password", updatedData)
}